module.exports = __webpack_public_path__ + "static/media/8OLA7.efcc930a.jpg";